<template>
  <div v-if="modalOpen">
    <q-dialog v-model="modalOpen" persistent class="user-profile">
      <q-card style="min-width: 650px">
        <q-card-section class="card-section">
          <div class="text-h6">User Profile</div>
        </q-card-section>

        <q-card-section class="q-pt-none card-content">
          <div class="user-profile-section">
            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="Username"
              :input-style="{ color: 'white' }"
              color="white"
              readonly
              dense
              :model-value="fields.UserID"
            />
            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="Last Login Date"
              :input-style="{ color: 'white' }"
              color="white"
              readonly
              dense
              :model-value="fields.LastLoginDate"
            />
          </div>
          <div class="user-profile-section">
            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="EP"
              :input-style="{ color: 'white' }"
              color="white"
              readonly
              dense
              :model-value="fields.UserPoint"
            />
            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="VP"
              :input-style="{ color: 'white' }"
              color="white"
              readonly
              dense
              :model-value="fields.VotePoint"
            />
          </div>
          <div class="user-profile-section">
            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="Referral Code"
              :input-style="{ color: 'white' }"
              color="white"
              dense
              :model-value="fields.ReferralCode"
              @update:model-value="(e) => fields.ReferralCode = e"
            />
            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="Refer By"
              :input-style="{ color: 'white' }"
              color="white"
              readonly
              dense
              :model-value="fields.ReferBy"
            />
          </div>
          <div class="user-profile-section">
            <q-select
              style="margin-top: 8px;"
              v-model="fields.UserType"
              map-options
              option-value="value"
              option-label="label"
              outlined
              rounded
              input-style="font-size:12px"
              color="grey"
              placeholder="User Type"
              dense
              dark
              label="User Type"
              emit-value
              :options="userLevel"
            />
            <q-select
              style="margin-top: 8px;"
              v-model="fields.UserBlock"
              map-options
              option-value="value"
              option-label="label"
              outlined
              rounded
              input-style="font-size:12px"
              color="grey"
              placeholder="User Type"
              dense
              dark
              label="Block User"
              emit-value
              :options="block"
            />
          </div>
          <div class="user-profile-section">
            <q-select
              style="margin-top: 8px;"
              v-model="fields.UserLoginState"
              map-options
              option-value="value"
              option-label="label"
              outlined
              rounded
              input-style="font-size:12px"
              color="grey"
              placeholder="Login  State"
              dense
              dark
              label="Login  State"
              emit-value
              :options="loginState"
            />

            <q-input
              square
              autofocus
              outlined
              label-color="white"
              outline-color="white"
              label="Created Date"
              :input-style="{ color: 'white' }"
              color="white"
              readonly
              dense
              :model-value="fields.CreateDate"
            />
          </div>
            <q-btn label="Update" class="user-profile-actins" @click="updateUser"/>
            <q-btn color="black" label="Close" v-close-popup/>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core'

export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'UserProfileModal',
  props: {
    open: {
      required: true,
      type: Boolean
    },
    userNum: {
      required: true,
      type: Number
    }
  },
  watch: {
    open (val) {
      this.modalOpen = val
      if(val) {
        this.getUserByID()
      } else {
        this.fields = {}
      }
    },
    modalOpen (val) {
      if (!val) {
        this.$emit('close')
      }
    }
  },
  data () {
    return {
      modalOpen: false,
      enableRegister: false,
      fields: {
        UserNum: null,
        UserName: null,
        UserPoint: null,
        VotePoint: null,
        UserID: null,
        UserBlock: null,
        ReferralCode: null,
        ReferBy: null,
        UserType: null,
        LastLoginDate: null,
        CreateDate: null
      },
      block: [
        {
          label: 'Block',
          value: '1'
        },
        {
          label: 'UnBlock',
          value: '0'
        }
      ],
      loginState: [
        {
          label: 'Online',
          value: '1'
        },
        {
          label: 'Offline',
          value: '0'
        }
      ]
    }
  },
  computed: {
    userLevel () {
      return this.getUserLevel()
    }
  }, 
  validations: {
  },
  methods: {
    ...mapActions({
      requestUserByID: 'user/requestUserByID',
      requestUpdateUser: 'user/requestUpdateUser'
    }),
    async getUserByID () {
      this.$q.loading.show()

      await this.recaptchaLoad('requestUserByID')

      await this.requestUserByID(this.userNum)
        .then((response) => {
          this.recaptchaLoad('requestUserByID')

          this.fields = response.data.data

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })
 
          this.$q.loading.hide()
        })
    },
    async updateUser () {
      this.$q.loading.show()

      await this.recaptchaLoad('requestUpdateUser')

      await this.requestUpdateUser(this.fields)
        .then((response) => {
          this.recaptchaLoad('requestUserByID')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          this.$emit('close')

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    }
  }
}
</script>
<style lang="scss">
.user-profile {
  .card-section {
    color: white;
    background-color: $backgroundHeader;
  }
  .card-content { 
    padding: 24px;
    background-color: $background;
    display: grid;
    grid-template-rows: 1fr;
    gap: 10px;

    .user-profile-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    .user-profile-actins {
      background-color: #FFC108;
    }
    .q-field__control:before {
      border-color: white;
    }
    .q-input {
      color: white;
    }
  }
}
</style>